import React, { useState } from 'react';
import { Header } from './components/Header';
import { ATLResonanceDashboard } from './components/ATLResonanceDashboard';
import { Footer } from './components/Footer';
export const App: React.FC = () => {
  const [timeRange, setTimeRange] = useState('30d');
  return <div className="min-h-screen bg-white font-sans flex flex-col" data-id="element-0">
      <Header timeRange={timeRange} setTimeRange={setTimeRange} data-id="element-1" />

      <main className="container mx-auto px-4 md:px-6 py-6 md:py-8 flex-grow" data-id="element-2">
        <ATLResonanceDashboard data-id="element-3" />
      </main>

      <Footer data-id="element-4" />
    </div>;
};